import { WorkItemUpdate } from 'src/Models/HistoryItem';
import { UserContact, UserManager } from 'src/Models/UserProfile';
import { WorkItem } from 'src/Models/WorkItem';
import { ArtimisActionData } from 'src/Models/ArtimisActionData';
export interface IManageViewTokens {
  authTokens: string;
  coreAPIToken: string;
  graphToken: string;
}
export interface IDisplayColumn {
  internalName: string;
  displayName: string;
  isDefault: boolean;
  customWidth?: number;
}
export interface IDisplayColumns {
  id: string;
  owner: string;
  displayColumnOptions: IDisplayColumn[];
}

export interface IViewableBy {
  type: number;
  value: string;
}

export interface IColumn {
  internalName: string;
  displayName: string;
}

export interface ISorting {
  column: IColumn;
  sortOrder: string;
}

export interface IDefaultSorting {
  column: string;
  sortOrder: string;
}

export class IOperator {
  id: number;
  operatorInternalName: string;
}

export interface IClause {
  column: IColumn;
  operator: IOperator;
  values: string[];
}
export interface IQueryGroup {
  id: string;
  relation: string;
  clause: IClause;
  index: number;
  queryGroupInfo: IQueryGroup[];
}

export interface IGroup {
  startIndex: number;
  endIndex: number;
  level: number;
}

export interface ICustomQuery {
  id: string;
  appID: string;
  type: string;
  name: string;
  default: boolean;
  owner: string;
  viewableBy: IViewableBy[];
  sorting: ISorting[];
  paging: {};
  queryGroups: IQueryGroup[];
  groupsInfo: IGroup[];
  folderId: any;
  isFavorite: boolean;
  isDefault: boolean;
  displayColumns: IDisplayColumn[];
}
export interface IUserContext {
  displayName: string;
  givenName: string;
  lastName: string;
  email: string;
  persona: string;
  hasTeam: boolean;
  flights: string[];
  displayColumns: IDisplayColumns;
  views: ICustomQuery[];
  userSettings: any;
  isUserExcluded: string;
  isUserInOrg: string;
}
export interface IManageViewProps {
  apiTokens: IManageViewTokens;
  user: IUserContext;
}

export interface IWorkItemUpdate {
  relations: any;
  fields: any;
  relatedItems: any;
  attachments: any;
  avatarUrl: string;
  id: number;
  workitemid: number;
  rev: number;
  revisedby: string;
  revisedDate: string;
  revisedFullDate: string;
  updateDetails: string;
  state: string;
  statechangedate: string;
  dategroup: string;
  modifiedBy: string;
}

export interface IHistoryCardProps {
  history: WorkItemUpdate;
}
export interface IHistoryDataProps {
  onClickHistory: Function;
  history: WorkItemUpdate[];
  selectedHistoryId: number | undefined;
}
export interface IHyperLinks {
  hyperlinks: IHistoryItem[];
}

export interface IHistoryItem {
  name: string;
  oldValue: any;
  newValue: any;
}
export interface IHistoryDetailsProps {
  history: WorkItemUpdate | undefined;
}

export interface ITechnicalFeedback {
  AdoId: number;
  DisplayId: number;
  ServiceName: string;
  State: string;
  Description: string;
  OfferingName: string;
  ScoreByOffering: number;
  SubState: string;
  PlannedSemester: string;
  FeedbackUrl: string;
  Title: string;
}
export const SURVEY_ATTACHMENT_VALUE = 'Survey' as const;
export interface IAttachmentItem {
  id: string;
  name: string;
  url: string;
  size: number;
  index?: number;
  date?: string;
  gps_pipadolaunchinfoquestion?: typeof SURVEY_ATTACHMENT_VALUE;
  isPIPADOAttachedFileDeleted?: boolean;
}
export interface IDictionary<T> {
  [Key: string]: T;
}
export interface IRelation {
  Attributes: IDictionary<object>;
  Rel: string;
  Url: string;
}
export interface FileCardProps {
  attachment: IAttachmentItem;
  existingAttachments: IAttachmentItem[];
  deleteAttachment: (attachment: IAttachmentItem) => void;
  fileDownload: (attachment: IAttachmentItem) => void;
  isDeleteDisabled?: boolean;
  showFileNameTooltip?: boolean;
}
export interface IRelationDataCustomReturn {
  netAddedWorkItem: string[];
  netAddedChildWorkItem: string[];
  netAddedRemoteWorkItem: string[];
  netAddedParentWorkItem: string[];
}

// Generated by GitHub Copilot | Updated on: 2026-08-26 | 5 lines modified | Added attachment categories for common and survey files
export interface IRelationAsyncDataCustomReturn {
  netAddedWorkItemAsyncData: Object[];
  netAddedChildWorkItemAsyncData: Object[];
  netAddedRemoteWorkItemAsyncData: Object[];
  netAddedParentWorkItemAsyncData: Object[];
}

export interface IRelationColumn {
  ID: number;
  Title: string;
  ActionOwner: string;
  Status: string;
  ChangedDate: string;
  ItemType: string;
  linkType: string;
  Rel: string;
  WorkItem: WorkItem | ArtimisActionData;
  URL?: string;
}
export interface ILeftTabData {
  statusUpdate: string;
  closureStatement: string;
}

export interface IUpdatedAttachment {
  updatedAttachments: IAttachmentItem[];
  newAttachments: IAttachmentItem[];
  deletedAttachments: IAttachmentItem[];
}
// Generated by GitHub Copilot | Updated on: 2026-08-31 | 1 line added | Added Launch attachment deletion flag

export interface ICommentItem {
  avatarUrl: string;
  name: string;
  createdDate: Date;
  content: string;
  id: number;
  uniqueName: string;
  isAdoComment: boolean;
}

export interface IPersonalDetails {
  userAlias: string;
  isManager: boolean;
}
export interface IGetUserAlias {
  userId: string;
}
export interface IUserContact {
  displayName: string;
  email: string;
  businessPhone: string[];
  officeLocation: string;
  department: string;
  jobTitle: string;
  displayPicture: any;
}
export interface IUserManager {
  displayName: string;
  email: string;
  businessPhone: string[];
  officeLocation: string;
  jobTitle: string;
  displayPicture: any;
}

export interface ICommentState {
  showEdit: boolean;
  hideDialog: boolean;
  userContactDetails: IUserContact;
  error: string;
  userManager: IUserManager;
  isCalloutVisible: boolean;
  buttonId: string;
  userAlias: string;
  managerAlias: string;
  displayName: string;
  selectedUser: string;
}
export interface IUserCardDetails {
  isCalloutVisible: boolean;
  buttonId: string;
  userContactDetails: UserContact;
  userManager: UserManager;
  managerAlias: string;
  error: string;
  onDismissFocus: boolean;
  selectedUser: string;
}
export interface IPartnerRegionAreaFromCountry {
  CoSellPartnerArea: CoSellPartnerArea;
  CoSellPartnerCountry: CoSellPartnerCountry;
  CoSellPartnerRegion: CoSellPartnerRegion;
}

export interface CoSellPartnerArea {
  id: number;
  partnerArea: string;
  partnerRegionId: string;
}
export interface CoSellPartnerCountry {
  id: number;
  partnerCountry: string;
}
export interface CoSellPartnerRegion {
  id: number;
  partnerRegion: string;
}

// Generated by GitHub Copilot | Updated on: 2026-08-26 | 1 line modified | Appended attachment category tracking
// Generated by GitHub Copilot | Updated on: 2026-08-26 | 5 lines modified | Replaced survey attachment marker
// Generated by GitHub Copilot | Updated on: 2026-08-31 | 1 line added | Added Launch attachment deletion flag
// Generated by GitHub Copilot | Updated on: 2026-09-11 | 1 line modified | Scoped filename tooltip support
